import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded';
import { GAME_GUIDE_LINK_CSS } from './gameGuideLink';
const ICON_CSS = css `
  & svg {
    font-size: 80%;
  }
`;
const LINK_CSS = css(GAME_GUIDE_LINK_CSS, css `
    display: inline-flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 0 5px;
  `);
export const GameGuideExternalLink = ({ url, label }) => {
    return (_jsxs("a", { css: LINK_CSS, href: url, target: '_blank', rel: 'noreferrer', children: [label, _jsx("span", { css: ICON_CSS, children: _jsx(LaunchRoundedIcon, {}) })] }));
};
